module.exports = __webpack_public_path__ + "img/exemple2.498e3163.png";